import { render, staticRenderFns } from "./onayBekleyen.vue?vue&type=template&id=1cef8abb"
import script from "./onayBekleyen.vue?vue&type=script&lang=js"
export * from "./onayBekleyen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports